import { useState } from 'react'
import { PropertySettings } from './PropertySettings'
import { LabelSettings } from './LabelSettings'
import { QuickReplySettings } from './QuickReplySettings'
import { AiSettings } from './AiSettings'
import { TicketStatusSettings } from './TicketStatusSettings'
import { AccountSecurity } from './AccountSecurity'

type SettingsView = 'fields' | 'labels' | 'ticket-statuses' | 'quick-replies' | 'ai' | 'account'

const VIEWS: [SettingsView, string][] = [
  ['fields', 'Custom fields'],
  ['labels', 'Labels'],
  ['ticket-statuses', 'Ticket statuses'],
  ['quick-replies', 'Quick replies'],
  ['ai', 'AI assistant'],
  ['account', 'Your account'],
]

/** The Settings tab groups every workspace-wide taxonomy editor behind one switcher, rather than
 *  each getting its own line in an already-long left rail. */
export function Settings() {
  const [view, setView] = useState<SettingsView>('fields')

  return (
    <div className="stack gap-4">
      <div className="cad-tabs" role="tablist">
        {VIEWS.map(([id, label]) => (
          <button
            key={id}
            type="button"
            role="tab"
            className="cad-tab"
            aria-selected={view === id}
            onClick={() => setView(id)}
          >
            {label}
          </button>
        ))}
      </div>

      {view === 'fields' && <PropertySettings />}
      {view === 'labels' && <LabelSettings />}
      {view === 'ticket-statuses' && <TicketStatusSettings />}
      {view === 'quick-replies' && <QuickReplySettings />}
      {view === 'ai' && <AiSettings />}
      {view === 'account' && <AccountSecurity />}
    </div>
  )
}
